import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";

import equitrackLogo from "../../../../assets/img/clients/equitrack.webp";

export default function StockTrack() {
    const caseStudy = new CaseStudyTemplate(
        "Stock-Track",
        (
            <div>
                <p>
                    Stocktrack integrates with Equitrack and offers management of stock, including deliveries, pick lists, stock taking and invoicing.
                </p>

                <p>
                    Currently utilised across the globe for a multi-national maintenance company to track and invoice stock used on offshore and onshore locations.
                </p>
            </div>
        ),
        // Project Showcase Thumbnail
        "https://around.createx.studio/assets/img/portfolio/list/06.png",
        new Company(
            "Equitrack",
            // Company Logo
            equitrackLogo
        ),
        "https://equitrack.co.uk/",
        [
            technologies.aspNET,
            technologies.telerik,
            technologies.azure,
            technologies.sqlServer
        ]
    )

    return (
        <CaseStudy caseStudy={caseStudy}></CaseStudy>
    )
}